import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {http_no_auth} from "@utils"
import {toast} from "react-toastify"
import {EMPTY_DATA} from "../../../utility/Utils"

export const getReestrForHome = createAsyncThunk('reestr/getReestrForHome', async (data, {rejectWithValue}) => {
    try {
        const response = await http_no_auth.post('/registration/v1/thing/last', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        return rejectWithValue(error.message)
    }
})

export const getStatisticFoundItemsCount = createAsyncThunk('reestr/getStatisticFoundItemsCount', async (data, {rejectWithValue}) => {
    try {
        const response = await http_no_auth.post('/registration/v1/thing/last', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        return rejectWithValue(error.message)
    }
})

export const getStatisticLostItemsCount = createAsyncThunk('reestr/getStatisticLostItemsCount', async (data, {rejectWithValue}) => {
    try {
        const response = await http_no_auth.post('/registration/v1/thing/last', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        return rejectWithValue(error.message)
    }
})

export const getStatisticGiveOwnerCount = createAsyncThunk('reestr/getStatisticGiveOwnerCount', async (data, {rejectWithValue}) => {
    try {
        const response = await http_no_auth.post('/registration/v1/thing/last', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        return rejectWithValue(error.message)
    }
})

export const getStatisticPutAuctionCount = createAsyncThunk('reestr/getStatisticPutAuctionCount', async (data, {rejectWithValue}) => {
    try {
        const response = await http_no_auth.post('/registration/v1/thing/last', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        return rejectWithValue(error.message)
    }
})

export const getCarouselForHome = createAsyncThunk('reestr/getCarouselForHome', async (data, {rejectWithValue}) => {
    try {
        const response = await http_no_auth.post('/registration/v1/thing/last', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        return rejectWithValue(error.message)
    }
})

export const getReestrById = createAsyncThunk('reestr/getReestrById', async (data, {rejectWithValue}) => {
    try {
        const response = await http_no_auth.post('/registration/v1/thing/last', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        return rejectWithValue(error.message)
    }
})
export const getReestrByIdForCompare = createAsyncThunk('reestr/getReestrByIdForCompare', async (data, {rejectWithValue}) => {
    try {
        const response = await http_no_auth.post('/registration/v1/thing/last', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        return rejectWithValue(error.message)
    }
})

export const getPersonByReestrView = createAsyncThunk('reestr/getPersonByReestrView', async (perId, {rejectWithValue}) => {
    try {
        const response = await http_no_auth.get(`/registration/v1/person/get/${perId}`)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        return rejectWithValue(error.message)
    }
})

export const getAttributeList = createAsyncThunk('reestr/getAttributeList', async (data, {rejectWithValue}) => {
    try {
        const response = await http_no_auth.post('/admin/v1/attribute/list', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data?.data
    } catch (error) {
        return rejectWithValue(error.message)
    }
})

export const getAttributeValueList = createAsyncThunk('reestr/getAttributeValueList', async (data, {rejectWithValue}) => {
    try {
        const response = await http_no_auth.post('/admin/v1/attribute-value/list', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data?.data
    } catch (error) {
        return rejectWithValue(error.message)
    }
})

export const getThingAttributeValueList = createAsyncThunk('reestr/getThingAttributeValueList', async (data, {rejectWithValue}) => {
    try {
        const response = await http_no_auth.post('/registration/v1/thing-attribute/list', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        return rejectWithValue(error.message)
    }
})


export const reestrSysSlice = createSlice({
    name: 'reestr_for_home',
    initialState: {
        reestr_list: [],
        reestr_carousel_list: [],
        reestr_statistic_list: [],
        reestr_by_id: [],
        reestr_compare: [],
        attribute: [],
        person_data_reestr: {},
        thingAttributeValue: [],
        statistic_lost_count: 0,
        statistic_found_count: 0,
        statistic_put_auction_count: 0,
        statistic_give_owner_count: 0,


        count_item: 0,
        total_count: 0,
        current_page: 0,
        isLoading: false
    },
    reducers: {},
    extraReducers: {
        [getReestrForHome.fulfilled]: (state, action) => {
            state.reestr_list = action.payload?.data
            state.current_page = action.payload?.page
            state.count_item = action.payload?.count
            state.total_count = action.payload?.total_count
            state.isLoading = false
        },
        [getReestrForHome.pending]: (state) => {
            state.isLoading = true
        },
        [getReestrForHome.rejected]: (state) => {
            toast.error("Error")
            state.isLoading = false
        },

        [getCarouselForHome.fulfilled]: (state, action) => {
            state.reestr_carousel_list = action.payload?.data
            state.current_page = action.payload?.page
            state.count_item = action.payload?.count
            state.total_count = action.payload?.total_count
            state.isLoading = false
        },
        [getCarouselForHome.pending]: (state) => {
            state.isLoading = true
        },
        [getCarouselForHome.rejected]: (state) => {
            toast.error("Error")
            state.isLoading = false
        },


        [getStatisticFoundItemsCount.fulfilled]: (state, action) => {
            state.statistic_found_count = action.payload?.total_count
        },
        [getStatisticLostItemsCount.fulfilled]: (state, action) => {
            state.statistic_lost_count = action.payload?.total_count
        },
        [getStatisticGiveOwnerCount.fulfilled]: (state, action) => {
            state.statistic_give_owner_count = action.payload?.total_count
        },
        [getStatisticPutAuctionCount.fulfilled]: (state, action) => {
            state.statistic_put_auction_count = action.payload?.total_count
        },


        [getReestrById.fulfilled]: (state, action) => {
            state.reestr_by_id = action.payload?.data
            state.isLoading = false
        },
        [getReestrById.pending]: (state) => {
            state.isLoading = true
        },
        [getReestrById.rejected]: (state) => {
            toast.error("Error")
            state.isLoading = false
        },


        [getReestrByIdForCompare.fulfilled]: (state, action) => {
            const data = action.payload?.data
            if (data?.length > 0) {
                state.reestr_compare = action.payload?.data
                state.isLoading = false
            } else {
                toast.error(EMPTY_DATA)
                state.isLoading = false
            }
        },
        [getReestrByIdForCompare.pending]: (state) => {
            state.isLoading = true
        },
        [getReestrByIdForCompare.rejected]: (state) => {
            toast.error("Error")
            state.isLoading = false
        },

        [getPersonByReestrView.fulfilled]: (state, action) => {
            state.person_data_reestr[action?.meta?.arg] = action.payload?.data
            state.isLoading = false
        },
        [getPersonByReestrView.pending]: (state) => {
            state.isLoading = true
        },
        [getPersonByReestrView.rejected]: (state) => {
            toast.error("Error")
            state.isLoading = false
        },

        [getAttributeList.fulfilled]: (state, actions) => {
            state.attribute = actions.payload
            state.isLoading = false
        },
        [getAttributeList.pending]: (state) => {
            state.isLoading = true
        },
        [getAttributeList.rejected]: (state, action) => {
            toast.error(action.payload)
            state.isLoading = false
        },

        // Attribute value list
        [getAttributeValueList.fulfilled]: (state, action) => {
            console.log(action.payload)
            // state.attributeValue[actions.meta?.arg?.attribute_id] = actions.payload
            state.isLoading = false
        },
        [getAttributeValueList.pending]: (state) => {
            state.isLoading = true
        },
        [getAttributeValueList.rejected]: (state, action) => {
            toast.error(action.payload)
            state.isLoading = false
        },

        // THING Attribute value list
        [getThingAttributeValueList.fulfilled]: (state, action) => {
            state.thingAttributeValue = action.payload?.data
            state.current_page = action.payload?.page
            state.count_item = action.payload?.count
            state.total_count = action.payload?.total_count
            state.isLoading = false
        },
        [getThingAttributeValueList.pending]: (state) => {
            state.isLoading = true
        },
        [getThingAttributeValueList.rejected]: (state, action) => {
            toast.error(action.payload)
            state.isLoading = false
        }
    }
})

export const {} = reestrSysSlice.actions
export default reestrSysSlice.reducer